import { GetParameterByName, QueryObjectToString } from 'helpers/NavigationHelper.types'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class NavigationHelper {
  static queryObjectToString: QueryObjectToString = (params) => {
    let str = ''
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) {
        if (str !== '') { str += '&' }
        str += `${key}=${encodeURIComponent(String(params[key]))}`
      }
    })

    return str
  }

  static getParameterByName: GetParameterByName = (name, url) => {
    const nameFormatted = name.replace(/[[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${nameFormatted}(=([^&#]*)|&|#|$)`, 'i')
    const results = regex.exec(url ?? window.location.href)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }
}
